<template>
  <div>
    <div class="form-group row">
      <div class="col-md-6">
        <el-input type="text"
                  style="width: 90%"
                  v-model="addInspectionTypeName"
                  placeholder="Add Inspection Type"/>
        <button class="btn btn-info btn-fill btn-sm btn-add" @click="addInspectionType" :disabled="addInspectionTypeNameEmpty">
          +
        </button>
      </div>
      <div class="col-md-6">
        <el-input type="text"
                  style="width: 90%"
                  v-model="addCategoryName"
                  placeholder="Add Category"/>
        <button class="btn btn-info btn-fill btn-sm btn-add" @click="addCategory" :disabled="addInspectionCategoryNameEmpty || isNotInspectionTypeSelected">
          +
        </button>
      </div>
    </div>
    <!-- dynamic -->
    <div class="row" style="margin-top: 10px;">
      <div class="col-md-12">
        <tabs v-model="inspectionTypeValue" :activeName="inspectionTypeValue" ref="inspectionTypeTabs" @tab-add="addInspectionType" @edit="removeInspectionType" @tab-click="handleClickInspectionType" value="Inspection Type" style="width: 100%">
          <tab-pane v-for="(inspectionType, inspectionTypeIndex) in digitalForm.inspectionTypes" :label="inspectionType.name" :key="inspectionType.name" :name="inspectionType.name" closable>
            <tabs v-model="inspectionCategoryValue" ref="inspectionCategoryTabs" @tab-add="addCategory" @edit="removeCategory" @tab-click="handleClickInspectionCategory" tab-position="left" style="min-height: 100px;">
              <tab-pane v-for="(category, categoryIndex) in inspectionType.categories" :label="category.name" :key="category.name" :name="category.name" closable>
                <div class="row" style="padding: 0 12px;">
                  <div class="col-md-12">
                    <div class="form-group align-left">
                      <label>Inspection Type</label>
                      <el-input type="text"
                                v-model="inspectionType.name"/>
                    </div>
                  </div>
                </div>
                <div class="row" style="padding: 0 12px;">
                  <div class="col-md-12">
                    <div class="form-group align-left">
                      <label>Category</label>
                      <el-input type="text"
                                v-model="category.name" />
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 15px;">
                  <div class="col-md-12 align-left">
                    <h6 style="margin-top: 12px;">Comments</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 align-left">
                    <el-input type="search" name="search" placeholder="Save Comment" clearable v-model="commentValue" style="width: 93%" />
                    <button class="btn btn-info btn-fill btn-sm btn-add" @click="addOrUpdateComment" :disabled="addInspectionCommentEmpty">
                      +
                    </button>
                  </div>
                </div>
                <el-table class="table-striped"
                          :data="category.comments"
                          border
                          :id="'comments-table-inspection-type-' + inspectionTypeIndex + '-category-' + categoryIndex"
                          style="margin-top: 12px; width: 100%;">
                  <el-table-column
                    prop="comment"
                    label="Comment">
                    <template slot-scope="props">
                      <span class="invisible">{{ props.row.id }}</span>
                      {{ props.row.value }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="110"
                    fixed="right"
                    label="Actions">
                    <template slot-scope="props">
                      <div style="text-align: center">
                        <p-button type="success" size="sm" icon @click="editComment(props.row)">
                          <i class="fa fa-edit"></i>
                        </p-button>
                        <p-button type="danger" size="sm" icon @click="removeComment(props.row)">
                          <i class="fa fa-times"></i>
                        </p-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </tab-pane>
            </tabs>
          </tab-pane>
        </tabs>
      </div>
    </div>
    <div class="row" style="margin-top: 12px;" v-if="canEdit">
      <div class="col-md-12">
        <button type="submit" :disabled="isSubmitDisabled" @click.prevent="validateAndSubmit" class="btn btn-fill btn-info btn-wd pull-right">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import {TabPane, Tabs} from 'element-ui'
import {mapGetters} from 'vuex'
import _ from 'lodash'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import {notifyError, notifySuccess} from 'src/utilities/utils'
import Constants from 'src/utilities/constants'
import {OK} from 'http-status-codes'
import {get} from 'vuex-pathify'
import Permissions from '@/utilities/permissions'

export default {
  props: ['data'],
  components: {
    PSwitch,
    Tabs,
    TabPane
  },
  computed: {
    digitalForm: get('inspectorApp/digitalForm@edit'),
    tabIndex: get('inspectorApp/digitalForm@tabIndex'),
    ...mapGetters({
      projectTypes: 'types/project',
    }),
    canEdit() {
      return this.$can('edit', Permissions.INSPECTOR_APP)
    },
    addInspectionTypeNameEmpty() {
      return this.addInspectionTypeName == null
    },
    addInspectionCategoryNameEmpty() {
      return this.addCategoryName == null
    },
    addInspectionCommentEmpty() {
      return this.commentValue == null || this.commentValue.length === 0
    },
    isNotInspectionTypeSelected() {
      return this.inspectionTypeValue == null
    },
    isSubmitDisabled() {
      return this.isProcessing
    }
  },
  data() {
    return {
      addInspectionTypeName: '',
      addCategoryName: '',
      commentValue: null,
      commentId: null,
      inspectionTypeValue: null,
      inspectionCategoryValue: null,
      isProcessing: false
    }
  },
  methods: {
    handleClickInspectionType(tab) {
      this.$store.set('inspectorApp/digitalForm/tabIndex@inspectionType', +tab.index)
      this.$store.set('inspectorApp/digitalForm/tabIndex@category', 0)
    },
    handleClickInspectionCategory(tab) {
      this.$store.set('inspectorApp/digitalForm/tabIndex@category', +tab.index)
    },
    async validateAndSubmit() {
      this.isProcessing = true

      if (await this.$validator.validateAll()) {
        const response = await this.$store.dispatch('save', {
          endpoint: 'digital-forms-v2',
          data: this.digitalForm
        })

        if (response.result === Constants.RETURN_CODES.SUCCESS) {
          notifySuccess(this, 'Successfully saved digital form')
          this.isProcessing = false
          return
        }

        notifyError(this, 'Failed to save digital form', response.errors)
      }
      this.isProcessing = false
    },
    addInspectionType() {
      const foundMatchingInspectionTypes = _.find(this.digitalForm.inspectionTypes, _.matchesProperty('name', this.addInspectionTypeName.trim()))
      if(_.isEmpty(foundMatchingInspectionTypes)) {
        this.$store.set('inspectorApp/digitalForm/addInspectionType', this.addInspectionTypeName.trim())
        this.inspectionTypeValue = this.addInspectionTypeName
        this.addInspectionTypeName = ''
        return
      }
      notifyError(this, 'The inspection type "' + this.addInspectionTypeName + '" exists. You can not create duplicates.')
    },
    removeInspectionType(targetName, action) {
      if (action === 'remove') {
        let tabs = this.digitalForm.inspectionTypes
        let activeName = this.inspectionTypeValue
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }

        this.inspectionTypeValue = activeName
        this.$store.set('inspectorApp/digitalForm/removeInspectionType', targetName)
      }
    },
    addCategory() {
      const existingInspectionTypeCategories = this.digitalForm.inspectionTypes[this.tabIndex.inspectionType].categories
      const foundCategory = _.find(existingInspectionTypeCategories, _.matchesProperty('name', this.addCategoryName.trim()))
      if(_.isEmpty(foundCategory)) {
        this.$store.set('inspectorApp/digitalForm/addCategory', this.addCategoryName.trim())
        this.inspectionCategoryValue = this.addCategoryName
        this.addCategoryName = ''
        this.$forceUpdate()
        return
      }
      notifyError(this, 'This category "' + this.addCategoryName + '" already exists. You can not have duplicates in the same inspection type.')
    },
    removeCategory(targetName, action) {
      if (action === 'remove') {
        let categoryTabs = this.digitalForm.inspectionTypes[this.tabIndex.inspectionType].categories
        let activeName = this.inspectionCategoryValue
        if (activeName === targetName) {
          categoryTabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = categoryTabs[index + 1] || categoryTabs[index - 1]
              if (nextTab) {
                activeName = nextTab.name
              }
            }
          })
        }

        this.inspectionCategoryValue = activeName
        this.$store.set('inspectorApp/digitalForm/removeCategory', targetName)
        this.$forceUpdate()
      }
    },
    addOrUpdateComment() {
      if (this.commentId) {
        this.$store.commit('inspectorApp/digitalForm/editComment', {
          id: this.commentId,
          value: this.commentValue
        })
      } else {
        this.$store.commit('inspectorApp/digitalForm/addComment', this.commentValue)
      }

      this.commentValue = null
      this.commentId = null
    },
    removeComment(commentToRemove) {
      this.$store.commit('inspectorApp/digitalForm/removeComment', commentToRemove)
      this.$forceUpdate()
    },
    editComment(commentToEdit) {
      this.commentId = commentToEdit.id
      this.commentValue = commentToEdit.value
    },
    getError(fieldName) {
      return this.errors.first(fieldName)
    }
  },
  async mounted() {
    const response = await this.$store.dispatch('inspectorApp/digitalForm/fetchDigitalForm')

    if (OK !== response.status) {
      notifyError(this, 'Failed to load digital form')
    }

    const firstInspectionType = _.get(this, 'digitalForm.inspectionTypes[0]')
    const firstCategory = _.get(firstInspectionType, 'categories[0]')

    if (firstInspectionType) {
      this.inspectionTypeValue = firstInspectionType.name
    }
    if (firstCategory) {
      this.inspectionCategoryValue = firstCategory.name
    }
  }
}
</script>

<style scoped>
.align-left {
  text-align: left;
}
.btn-add {
  margin: 0 0 2px 6px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
